import React, { Component } from 'react'
import { Container, Typography, CardContent, Card /* , CardHeader */ } from '@material-ui/core';
import StatusBookingPayment from './partials/StatusBookingPayment'
//import PurchaseDetail from './../CheckoutPage/partials/PurchaseDetail'

export default class Rejected extends Component {
    constructor(props) {
        super(props)

    }

    render() {
        const { content } = this.props
        return (
            <Container className={`container_thankyoupage rejected`} maxWidth="md" >
                <Card className="card_container rejected">
                    {/* <CardHeader
                        avatar={<Icon>{content.icon}</Icon>}
                        title={<Typography variant="h2">{content.statusMessage}</Typography>}
                    /> */}
                    <CardContent>
                        <div className="inner-content">
                            <div className="mensaje-status text-center">
                                <Typography variant="h1" className="title-message">{content.title}</Typography>
                            </div>
                            <StatusBookingPayment content={content} />
                        </div>
                    </CardContent>
                </Card>
            </Container>
        )
    }
}